import ThreeDPage from './ThreeDPage';

export default ThreeDPage;
